(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["action-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
    if (localStorage.getItem('action-popup-closed') == null) {
      const actionPopup = document.getElementById('action-popup');
      setTimeout(() => {
        new bootstrap.Modal(actionPopup)
          .show();
      }, parseInt(actionPopup.getAttribute('data-timeout')) * 1000);

      actionPopup.addEventListener('hidden.bs.modal', event => {
        localStorage.setItem('action-popup-closed', true);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
        const buttonTop = document.querySelector('.back-to-top');
        if (!buttonTop) return;

        document.addEventListener('scroll', function () {
            if (window.scrollY <= 286) {
            buttonTop.classList.add('d-none');
            } else {
            buttonTop.classList.remove('d-none');
            }
        });

        buttonTop.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    initCartRecommendationsSwiper();
    initCartRecommendationsEvents();
  });

  document.addEventListener('cart:update', function () {
    initCartRecommendationsSwiper();
  });

  let recoSwiperInstance = null;

  function initCartRecommendationsSwiper() {
    const container = document.querySelector('.cart-recommendations__products');
    if (!container) return;

    if (recoSwiperInstance) {
      recoSwiperInstance.destroy(true, true);
      recoSwiperInstance = null;
    }

    recoSwiperInstance = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 5,
      loop: false,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      watchOverflow: true, 
      navigation: {
        nextEl: '.cart-recommendations__products .swiper-button-next',
        prevEl: '.cart-recommendations__products .swiper-button-prev',
      },
      pagination: { el: '.swiper-pagination', clickable: true },
      autoplay: { delay: 3000, disableOnInteraction: true },
    });
  }

  function initCartRecommendationsEvents() {
    document.addEventListener('change', function (e) {
      const select = e.target.closest('[data-variant-select]');
      if (!select || select.tagName !== 'SELECT') return;

      const productEl = select.closest('.cart-recommendations__product');
      const button = productEl.querySelector('[data-add-to-cart]');
      const priceEl = productEl.querySelector('[data-price-wrapper] .price');

      const selectedOption = select.options[select.selectedIndex];
      button.setAttribute('data-variant-id', selectedOption.value);
      if (priceEl) priceEl.textContent = selectedOption.getAttribute('data-price');
    });

    document.addEventListener('click', function (e) {
      const button = e.target.closest('[data-add-to-cart]');
      if (!button) return;

      const productEl = button.closest('.cart-recommendations__product');
      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      if (!button.id) {
        button.id =
          'cart-recommendations-add-' +
          (productEl.getAttribute('data-product-id') || Math.random().toString(36).slice(2));
      }

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Ajout...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw err;
            });
          }
          return response.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          button.textContent = 'Ajouté ✓';
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: button.id,
                data: {
                  itemCount: cart.item_count,
                  variantId: variantId,
                  productId: productEl.getAttribute('data-product-id'),
                  source: 'cart-recommendations',
                },
              },
            })
          );
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          console.error(err);
          button.textContent = 'Erreur';
          document.dispatchEvent(
            new CustomEvent('cart:error', {
              bubbles: true,
              detail: { sourceId: button.id, data: err },
            })
          );
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1500);
        });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.gift-product__actor').addEventListener('click', function (event) {
      let target = event.target;

      if (target.tagName == 'LI') {
        if (target.getAttribute('data-value') == 1) {
          document.querySelector('.gift-product_inputs').classList.add('d-none');
          document.querySelector('#email').value = '';
          document.querySelector('#name').value = '';
          document.querySelector('#date').value = '';
          document.querySelector('#message').value = '';

        } else {
          document.querySelector('.gift-product_inputs').classList.remove('d-none');
        }
      }
    });
    
    flatpickr('#date', {
      enableTime: false,
      dateFormat: "d-m-Y",
      locale: 'fr',
      defaultDate: "today",
      minDate: "today",
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.gift-product__actor').addEventListener('click', function (event) {
      let target = event.target;

      if (target.tagName == 'LI') {
        if (target.getAttribute('data-value') == 1) {
          document.querySelector('.gift-product_inputs').classList.add('d-none');
          document.querySelector('#email').value = '';
          document.querySelector('#name').value = '';
          document.querySelector('#date').value = '';
          document.querySelector('#message').value = '';

        } else {
          document.querySelector('.gift-product_inputs').classList.remove('d-none');
        }
      }
    });
    
    flatpickr('#date', {
      enableTime: false,
      dateFormat: "d-m-Y",
      locale: 'fr',
      defaultDate: "today",
      minDate: "today",
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grid-density-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    const input = event.target;
    if (
      input instanceof HTMLInputElement &&
      (input.name === 'grid' || input.name === 'grid-mobile')
    ) {
      document.querySelectorAll('results-list').forEach(function(resultsList) {
        if (typeof resultsList.updateLayout === 'function') {
          resultsList.updateLayout(event);
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (localStorage.getItem('newsletter-popup-closed') == null) {
      const newsletterPopup = document.getElementById('newsletter-popup');
      setTimeout(() => {
        new bootstrap.Modal(newsletterPopup).show();
      }, parseInt(newsletterPopup.getAttribute('data-timeout')) * 1000);

      newsletterPopup.addEventListener('hidden.bs.modal', (event) => {
        localStorage.setItem('newsletter-popup-closed', true);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["post-products"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {

    new Swiper('.post-products__pills__contents_products', {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          centeredSlides: false,
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        },
        768: {
          slidesPerView: 2.5,
          centeredSlides: false,
          spaceBetween: 20,
          navigation: false,
          pagination: false,
        },
      },
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-choice"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.querySelector('.product-choice')) {
        for (let choice of document.querySelectorAll('.product-choice')) {
            choice.addEventListener('click', function (event) {
                if (event.target.tagName == 'LI') {
                    event.target.parentNode.previousElementSibling.value = event.target.dataset.value;
                    event.target.parentNode.querySelector('.active').classList.remove('active');
                    event.target.classList.add('active');
                }
            });
        }
        
      }

        
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {

        document.addEventListener('click', (event) => {
            const button = event.target.closest('[data-quiz]');
            if (!button) return;

            event.preventDefault();
            event.stopPropagation();

            const quizellBtn = document.querySelector('.Quizell-PopUp-Btn');

            if (quizellBtn) {
                quizellBtn.click();
            } else if (typeof openQuizModal === 'function') {
                openQuizModal(button.dataset.quiz);
            } else {
                console.warn('Quizell pas encore chargé');
            }
        }, true);

    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {

    localStorage.removeItem('show_variants');
    
    document.querySelector('.variant-picker__form').addEventListener('click', function (e) {

      if (e.target.classList.contains('variant-option__more')) {
        let more = e.target,
          className = more.getAttribute('data-show'),
          showVariants = localStorage.getItem('show_variants');

        more.classList.add('d-none');
        
        more.parentNode.classList.add('variant-options__show');

        if (showVariants) {
          showVariants += `,${className}`;

          localStorage.setItem('show_variants', showVariants);

        } else {
          localStorage.setItem('show_variants', className);
        }

        for (const element of document.querySelectorAll(`label.${className}`)) {
          element.classList.remove('variant-option__hide');
        }

      }

    });
  });
  } catch(e) { console.error(e); }
})();

})();
